/**
 * Modal de anuncio "Advocates se renovó".
 *
 * La ventana de visibilidad la controla la columna `announcement_end_date` de la
 * company (se setea por DB con un UPDATE masivo al lanzar). NULL = modal apagado.
 * El modal se muestra mientras `now < announcement_end_date`.
 *
 * Es un Modal Especial más, así que le rigen las dos reglas de la familia:
 * empresa no excluida (`excludedCompanies.constants.ts`) y **una aparición cada
 * 7 días por persona** (`specialModalFrequency.constants.ts`, ADV-3347). El
 * Layout suma además su propio gate de "una vez por login" (flag de
 * sessionStorage que arma LoginPage).
 */

import { isExcludedFromSpecialModals } from 'constants/excludedCompanies.constants';
import {
  SpecialModalUserId,
  wasSpecialModalShownRecently
} from 'constants/specialModalFrequency.constants';

/**
 * Kill-switch de frontend: en julio 2026 se pausó este modal ("hasta nueva
 * orden") para dar prioridad al modal del webinar (ver webinar.constants.ts).
 * Para reactivarlo basta con volverlo `true`.
 *
 * Apagado de nuevo desde el 28-jul-2026: lo reemplaza el modal de lanzamiento
 * AdvPro del webinar del 5 de agosto (ver advproLaunch.constants.ts).
 */
export const ANNOUNCEMENT_MODAL_ENABLED = false;

/** Key de este modal para la marca de frecuencia de la familia. */
export const ANNOUNCEMENT_MODAL_KEY = 'announcement_renovacion';

export const isAnnouncementWindowOpen = (
  endDate?: string | Date | null
): boolean => {
  if (!endDate) return false;
  return Date.now() < new Date(endDate).getTime();
};

/**
 * Decide si el modal de anuncio debe mostrarse: kill-switch prendido + ventana
 * de la company abierta + empresa no excluida + company sin descarte permanente
 * (DB) + ventana de frecuencia vencida para esta persona.
 */
export const shouldShowAnnouncementModal = (
  endDate: string | Date | null | undefined,
  dismissedForCompany: boolean | undefined,
  userId: SpecialModalUserId
): boolean => {
  if (!ANNOUNCEMENT_MODAL_ENABLED) return false;
  // Sin id no hay forma de recordar la última aparición: mostrarlo
  // significaría reaparecer en cada carga.
  if (userId === undefined || userId === null || userId === '') return false;
  if (!isAnnouncementWindowOpen(endDate)) return false;
  if (isExcludedFromSpecialModals()) return false;
  if (dismissedForCompany === true) return false;
  if (wasSpecialModalShownRecently(ANNOUNCEMENT_MODAL_KEY, userId)) {
    return false;
  }
  return true;
};
